import { render, staticRenderFns } from "./supervisionAnswerListCustomer.vue?vue&type=template&id=e0022dc0"
import script from "./supervisionAnswerListCustomer.vue?vue&type=script&lang=js"
export * from "./supervisionAnswerListCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports